<template>
  <b-sidebar
    id="comment-form-sidebar"
    :visible="isCommentFormSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @shown="getData(commentData)"
    @hidden="resetForm"
    @change="(val) => $emit('update:is-comment-form-sidebar-active', val)"
  >
    <template #default="{ hide }"> 
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Comment Form
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="types"
            rules="required"
          >
            <b-form-group
              label="Types"
              label-for="types"
            >
              <v-select
                id="types"
                class="d-inline-block w-100"
                :clearable="false"
                v-model="Data.types"
                placeholder="Get Types"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :reduce="(option) => option.value"
                :options="typesData"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <b-tabs  v-if="Data.types == 'comment'">
            <b-tab v-for="(lang,i) in langs" :key="'lang-tab-'+i" :title="lang.name">
              <validation-provider
                #default="validationContext"
                :name="'name_'+lang.code"
                rules="min:0"
              >
                <b-form-group
                  label="Name"
                  :label-for="'name_'+lang.code"
                >
                  <b-form-input
                    :id="'name_'+lang.code"
                    v-model="Data.name[lang.code]"
                    autofocus
                    :state="getValidationState(validationContext)"
                    trim
                    :placeholder="'Name ('+lang.code+')'"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>

              <validation-provider
                #default="validationContext"
                :name="'comment_'+lang.code"
                rules="min:0"
              >
                <b-form-group
                  label="Comment"
                  :label-for="'comment_'+lang.code"
                >
                  <b-form-textarea
                    :id="'comment_'+lang.code"
                    v-model="Data.comment[lang.code]"
                    autofocus
                    :state="getValidationState(validationContext)"
                    trim
                    :placeholder="'Comment ('+lang.code+')'"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-tab>
          </b-tabs>

          <hr v-if="Data.types == 'comment'" />
          <validation-provider
            #default="validationContext"
            name="email"
            rules="min:0"
            v-if="Data.types == 'comment'"
          >
            <b-form-group
              label="Email"
              label-for="email"
            >
              <b-form-input
                id="email"
                v-model="Data.email"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="Email"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="url"
            rules="min:0"
            v-if="Data.types == 'comment'"
          >
            <b-form-group
              label="Url"
              label-for="url"
            >
              <b-form-input
                id="url"
                v-model="Data.url"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="Url"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="rating"
            rules="min:0"
            v-if="Data.types == 'comment'"
          >
            <b-form-group
              label="Rating"
              label-for="rating"
            >
              <!-- <b-form-rating
                id="rating"
                variant="warning" 
                inline
                v-model="Data.rating"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="Rating"
              /> -->
              <b-form-input
                :id="'rating'"
                v-model="Data.rating"
                :state="getValidationState(validationContext)"
                trim
                :placeholder="'Rating'"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <div class="border rounded p-2" v-if="Data.types == 'comment'">
            <h4 class="mb-1">
              Image
            </h4>
            <b-media
              no-body
              vertical-align="center"
              class="flex-column flex-md-row"
            >
              <b-media-aside>
                <b-img
                  ref="refPreviewEl"
                  :src="Data.image_path? Data.image_path: require('@/assets/images/no-image.png')"
                  height="110"
                  width="170"
                  class="rounded mr-2 mb-1 mb-md-0"
                />
              </b-media-aside>
              <b-media-body>
                <b-card-text class="my-50"></b-card-text>
                <div class="d-inline-block">
                  <b-form-file
                    ref="refInputEl"
                    v-model="Data.imgFile"
                    accept=".jpg, .png, .gif, .webp, .jpeg"
                    placeholder="Choose file"
                    @input="inputImageRenderer"
                  />
                </div>
                <b-card-text class="my-50">
                  <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" v-if="Data.image" @click="revomeImage">Remove Image</b-button>
                </b-card-text>
              </b-media-body>
            </b-media>
          </div>

          <validation-provider
            #default="validationContext"
            name="iframe"
            rules="required"
            v-if="Data.types == 'iframe'"
          >
            <b-form-group
              label="iframe"
              label-for="iframe"
            >
              <b-form-input
                id="iframe"
                v-model="Data.iframe"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="iframe"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <br/>

          <validation-provider
            #default="validationContext"
            name="IsActive"
            rules="min:0"
          >
            <b-form-group
              label="Is Active"
              label-for="IsActive"
            >
              <b-form-checkbox
                id="isactive"
                checked="true"
                class="custom-control-success"
                v-model="Data.is_active"
                switch
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              Submit
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
  import { $themeConfig } from '@themeConfig'
  import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback, BButton,BTabs, BTab,BFormRating
  } from 'bootstrap-vue'
  import {
  BCard,BCardText,BMedia,BMediaAside,BMediaBody,BAvatar,BImg,BLink,BFormFile
  } from 'bootstrap-vue'
  import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { ref, onUnmounted, onMounted } from '@vue/composition-api'
  import { required, alphaNum, email, password,confirmed } from '@validations'
  import formValidation from '@core/comp-functions/forms/form-validation'
  import Ripple from 'vue-ripple-directive'
  import vSelect from 'vue-select'
  import store from '@/store'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import { useToast } from 'vue-toastification/composition'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import commentStoreModule from '../commentStoreModule'
  import useCommentList from '../comment-list/useCommentList'
  import { quillEditor } from 'vue-quill-editor'
  import languagesStoreModule from '@/views/languages/languagesStoreModule'

  export default {
    components: {
      BSidebar,
      BForm,
      BFormGroup,
      BFormInput,
      BFormTextarea,
      BFormCheckbox,
      BFormInvalidFeedback,
      BButton,
      BTabs, BTab,BFormRating,
      BCard,BCardText,BMedia,BMediaAside,BMediaBody,BAvatar,BImg,BLink,BFormFile,
      vSelect,
      quillEditor,
      ValidationProvider,
      ValidationObserver,
    },

    directives: {
      Ripple,
    },

    model: {
      prop: 'isCommentFormSidebarActive',
      event: 'update:is-comment-form-sidebar-active',
    },

    props: {
      isCommentFormSidebarActive: {
        type: Boolean,
        required: true,
      },
      commentData: {
        type: Object,
        required: false,
      },
    },

    computed: {
      currentLocale() {
        return this.$i18n.locale;
      },
    },

    setup(props, { emit }) {
      const {  appRef } = $themeConfig.app
      const toast = useToast()
      const refInputEl = ref(null);
      const refPreviewEl = ref(null)

      const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => {
          refPreviewEl.value.src = base64 
      })

      const revomeImage = ()=>{
        Data.value.image_path = require('@/assets/images/no-image.png');
        Data.value.image = '';
      }

      const userStorage = JSON.parse(localStorage.getItem('userData'));

      const blankData = {
        created_by:userStorage.id,
        iframe:'',
        is_active:true,
        //  group_id:'',
        url:'',
        types:'iframe',
      }

      const COMMENT_STORE_MODULE_NAME = 'app-comment';
      if (!store.hasModule(COMMENT_STORE_MODULE_NAME)) store.registerModule(COMMENT_STORE_MODULE_NAME, commentStoreModule)
      onUnmounted(() => {
          if (store.hasModule(COMMENT_STORE_MODULE_NAME)) store.unregisterModule(COMMENT_STORE_MODULE_NAME)
      });

      const LANGUAGE_STORE_MODULE_NAME = 'app-languages';
      if (!store.hasModule(LANGUAGE_STORE_MODULE_NAME)) store.registerModule(LANGUAGE_STORE_MODULE_NAME, languagesStoreModule)
      onUnmounted(() => {
          if (store.hasModule(LANGUAGE_STORE_MODULE_NAME)) store.unregisterModule(LANGUAGE_STORE_MODULE_NAME)
      });

      const {
        groups,
      } = useCommentList();

      const typesData = ref([
        {
          title:'Iframe',
          value:'iframe'
        },
        {
          title:'Comment',
          value:'comment'
        },
      ]);

      const langs = ref([]);
      const Data = ref(JSON.parse(JSON.stringify(blankData)))

      const resetData = () => {
        Data.value = JSON.parse(JSON.stringify(blankData))
      }

      const getData = (data)=>{
        Data.value.image_path = JSON.parse(JSON.stringify(require('@/assets/images/no-image.png')))

        if(data){
          data.is_active = data.is_active?true:false;
          Data.value  = JSON.parse(JSON.stringify(data));

          if(data.image){
            Data.value.image_path = data.fullpath;
          }
        }
      }

      const onSubmit = () => {
        Data.value.is_active = Data.value.is_active?1:0;
        Data.value.path = '/var/www/html/uploadfiles/uploads/'+appRef+'/comment/';
        Data.value.savepath = 'uploads/'+appRef+'/comment/';
          
        let formData = new FormData();

        for(const [key, value] of Object.entries(Data.value)) {
          if(key == 'name' || key == 'comment') {
            formData.append(key, JSON.stringify(value));
          } else {
            formData.append(key, value);
          }
        }

        if(Data.value.id){
          let datap = {
            formData:formData,
            id:Data.value.id
          }
          
          store.dispatch('app-comment/updateData', datap)
            .then((res) => {
              if(res.data.success) {
                toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: `Success`,
                    icon: 'BellIcon',
                    variant: 'success',
                    text: `${res.data.message}`,
                  },
                });

                emit('refetch-data')
                emit('update:is-comment-form-sidebar-active', false)
              } else {
                toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: `Error`,
                    icon: 'BellIcon',
                    variant: 'danger',
                    text: `${res.data.message}`,
                  },
                });
              }
            }
          )
        } else {
          store.dispatch('app-comment/addData', formData)
            .then((res) => {
              if(res.data.success) {
                toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: `Success`,
                    icon: 'BellIcon',
                    variant: 'success',
                    text: `${res.data.message}`,
                  },
                });

                emit('refetch-data')
                emit('update:is-comment-form-sidebar-active', false)
              } else {
                toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: `Error`,
                    icon: 'BellIcon',
                    variant: 'danger',
                    text: `${res.data.message}`,
                  },
                });
              }
            }
          )
        }
      }
        
      const {
        refFormObserver,
        getValidationState,
        resetForm,
      } = formValidation(resetData);

      const getLangs = (fil)=>{
        store.dispatch('app-languages/fetchData', fil)
          .then((res) => {
            if(res.data.success) {
              langs.value = res.data.data;
            }
          }
        );
      }

      let filter = {
        is_active:1, 
      }

      getLangs(filter);

      return {
        groups,
        Data,
        onSubmit,
        refFormObserver,
        getValidationState,
        resetForm,
        getData,
        typesData,
        langs,
        refInputEl,
        refPreviewEl,
        inputImageRenderer,
        revomeImage
      }
    },
  }
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/quill.scss';
</style>